<template>
  <template v-if="hasNoImage">
    <!-- fixedImageAspect 時のみ画像枠を固定アスペクト比で囲み、カード高さを一定にする。非指定時は従来の DOM を維持し回帰を避ける -->
    <div v-if="fixedImageAspect" class="mb-4 aspect-[3/2] w-full overflow-hidden md:mb-0">
      <img alt="no-image" src="@/assets/img/no-image.svg" :class="imageClass" />
    </div>
    <img v-else alt="no-image" src="@/assets/img/no-image.svg" :class="imageClass" />
  </template>
  <template v-else-if="!hasMultipleImages">
    <div v-if="fixedImageAspect" class="mb-4 aspect-[3/2] w-full overflow-hidden md:mb-0">
      <OptimizedImage alt="experience-image" :class="imageClass" :image-url="images[0].imageUrl" :optimized-image-options="{ width: 560 }" />
    </div>
    <OptimizedImage v-else alt="experience-image" :class="imageClass" :image-url="images[0].imageUrl" :optimized-image-options="{ width: 560 }" />
  </template>
  <template v-else>
    <Carousel :opts="opts">
      <CarouselContent>
        <CarouselItem v-for="image in images" :key="image.id">
          <div v-if="fixedImageAspect" class="mb-4 aspect-[3/2] w-full overflow-hidden md:mb-0">
            <OptimizedImage alt="experience-image" loading="lazy" :class="imageClass" :image-url="image.imageUrl" :optimized-image-options="{ width: 560 }" />
          </div>
          <OptimizedImage v-else alt="experience-image" loading="lazy" :class="imageClass" :image-url="image.imageUrl" :optimized-image-options="{ width: 560 }" />
        </CarouselItem>
      </CarouselContent>
      <CarouselPrevious v-if="!isSP" class="md:hidden md:group-hover:block" />
      <CarouselNext v-if="!isSP" class="md:hidden md:group-hover:block" />
      <CarouselDotIndicator v-if="!shouldDisableCarousel" class="md:hidden md:group-hover:flex" />
    </Carousel>
  </template>
</template>

<script setup lang="ts">
import { Carousel, CarouselContent, CarouselNext, CarouselPrevious, CarouselDotIndicator } from '@/components/lib/shadcn-vue/carousel';
import CarouselItem from '@/components/lib/shadcn-vue/carousel/CarouselItem.vue';
import { OptimizedImage } from '@/wabunka-src/common/components';
import { useIsSP } from '@/wabunka-src/common/composables';
import type { ExperienceImageListViewModel } from '@/wabunka-src/features/Experience';

interface Props {
  images: ExperienceImageListViewModel;
  disableCarouselOnSp?: boolean;
  // 画像枠を固定アスペクト比 + object-cover にしてカードサイズを一定にする。呼び出し側が variant 判定で渡す
  fixedImageAspect?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  disableCarouselOnSp: false,
  fixedImageAspect: false,
});

const hasNoImage = computed<boolean>(() => props.images.length === 0);
const hasMultipleImages = computed<boolean>(() => props.images.length > 1);
const isSP = useIsSP();
const shouldDisableCarousel = computed(() => isSP.value && props.disableCarouselOnSp);
const opts = computed(() => ({
  active: !shouldDisableCarousel.value,
}));
// fixedImageAspect 時は枠を埋める object-cover、非指定時は従来どおり画像が高さを決める w-full
const imageClass = computed(() => ['transition-all duration-500 md:group-hover:scale-[102%]', props.fixedImageAspect ? 'h-full w-full object-cover' : 'mb-4 w-full md:mb-0']);
</script>
